import { createSelector } from 'reselect';
import { EkoHigienaStore } from '../store.types';

const cookiePolicyPopup = (state: EkoHigienaStore) => state.cookiePolicyPopup;

export const selectIsCookiePopupVisible = createSelector(
  [cookiePolicyPopup],
  cookiePolicyPopup => { return cookiePolicyPopup.isPopupVisible }
);